import ScopedBlogEdit from '@/components/blog/scoped-blog-edit';
import { ROUTES } from '@/config/routes';
import { clubSidebar } from '@/config/sidebarConfig';
import { useAuthStore } from '@/stores/auth-store';

export default function ClubBlogEdit() {
  const user = useAuthStore(s => s.user);
  const clubId = user?.clubId;

  return (
    <ScopedBlogEdit
      sidebarConfig={clubSidebar}
      listRoute={ROUTES.CLUB_BLOG}
      scopePayload={clubId ? { clubId } : undefined}
    />
  );
}
